import React from 'react';
import './Badge.css';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

/**
 * Reusable Badge component for status indicators
 */
const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'medium',
  className = ''
}) => {
  const variantClass = `common-badge--${variant}`;
  const sizeClass = `common-badge--${size}`;
  const badgeClassName = className 
    ? `common-badge ${variantClass} ${sizeClass} ${className}`.trim()
    : `common-badge ${variantClass} ${sizeClass}`.trim();

  return (
    <span className={badgeClassName}>
      {children}
    </span>
  );
};

export default Badge;

